import { useMemo } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { AssistantApi, createAssistantApi } from '@api/assistant/assistantApi';

/**
 * Binds the assistant client to the current Auth0 session.
 *
 * Uses the raw ID token (not the access token), which is what `src/api/api.tsx` sends to
 * frontend-service — the assistant sits behind the same gateway.
 */
export const useAssistantApi = (): AssistantApi => {
  const { getIdTokenClaims, getAccessTokenSilently } = useAuth0();

  return useMemo(
    () =>
      createAssistantApi({
        getToken: () => getIdTokenClaims().then(claims => claims?.__raw),
        refreshToken: () => getAccessTokenSilently({ cacheMode: 'off' }).then(() => getIdTokenClaims()).then(claims => claims?.__raw),
      }),
    [getIdTokenClaims, getAccessTokenSilently],
  );
};

export default useAssistantApi;
